import React, { useState } from 'react';
import { Button, Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import { AwesomeButton } from 'react-awesome-button';
import 'react-awesome-button/dist/themes/theme-blue.css';
import UserDetails from './UserDetails';
function Cart() {
	const [isOpen, setIsOpen] = useState(false);
	const toggleOpen = () => {
		setIsOpen(!isOpen);
	};
	return (
		<div className='cart'>
			<UserDetails isOpen={isOpen} toggleUserDetails={toggleOpen} />
			<Card className='cart__card'>
				<CardHeader className='border-0 text-center'>
					<div className='cart__item d-flex p-3 mt-2'>
						<i className='fa fa-user-circle mt-1 text-muted'></i>
						<p className='user__name mb-0 ms-2'>Jimmy Sullivan</p>
						<i
							className='ms-auto fa fa-edit text__primary pointer'
							onClick={toggleOpen}
						></i>
					</div>
					<p className='cart__title'>Cart</p>
					<p className='cart__subtitle'>Payment Pending</p>
					<Button className='btn__total mb-4'>Total AED 1050</Button>
				</CardHeader>
				<CardBody>
					<div className='cart__item pt-3 mb-5'>
						<div className='d-flex'>
							<p className='item__title px-2'>
								Sunset Yoga - Ladies Night
							</p>
							<div className='ms-auto me-3'>
								<i className='fa fa-times pointer btn__times'></i>
							</div>
						</div>
						<hr />
						<div className='d-flex px-2'>
							<p className='my-2 item__details'>Date:</p>
							<p className='my-2 ms-auto item__details'>
								12 Feb,2022
							</p>
						</div>
						<hr />
						<div className='d-flex px-2'>
							<p className='my-2 item__details'>Date:</p>
							<p className='my-2 ms-auto item__details'>
								12 Feb,2022
							</p>
						</div>
						<hr />
						<div className='d-flex px-2'>
							<p className='my-2 item__details'>Total:</p>
							<p className='my-2 ms-auto item__details'>
								AED 1050
							</p>
						</div>
					</div>
				</CardBody>
				<CardFooter className='border-0 px-0 pt-4 pb-0'>
					<div className='text-center'>
						<AwesomeButton type='secondary' className='w-40'>
							Cancel
						</AwesomeButton>
						<AwesomeButton type='primary' className='w-60'>
							Book Now
						</AwesomeButton>
					</div>
				</CardFooter>
			</Card>
		</div>
	);
}

export default Cart;
